import React from "react";
import { ToastPosition, ToastVariant } from "common/enums/controls/toast.enum";
import ToastMessage from "./ToastMessage";
import { createRoot } from "react-dom/client";

export class ToastMessageUtil {
  private static _modalRoot?: HTMLDivElement = undefined;

  public static show(
    message: string,
    variant: ToastVariant,
    position = ToastPosition.TOP,
    duration = 3000
  ) {
    if (!ToastMessageUtil._modalRoot) {
      ToastMessageUtil.getRootRef();
    }
    const element: HTMLDivElement = document.createElement("div");
    const handleClose = () => {
      try {
        if (ToastMessageUtil?._modalRoot?.hasChildNodes()) {
          ToastMessageUtil?._modalRoot?.removeChild(element);
        }
      } catch (ex) {
        console.error("Error while removing toast message: ", ex);
      }
    };
    const component = React.createElement(
      ToastMessage,
      {
        variant: variant,
        position: position,
        duration: duration,
        onClose: handleClose
      },
      message
    );

    // Use createRoot and render the component
    const root = createRoot(element);
    root.render(component);

    // Append the element to the modal root
    ToastMessageUtil?._modalRoot?.appendChild(element);
  }

  private static getRootRef() {
    ToastMessageUtil._modalRoot = document.getElementById(
      "modal"
    ) as HTMLDivElement;
  }
}
